/* eslint-disable no-unused-vars */
import { api } from "@/axios";
import router from "@/router";
import { permissionsMiddleWare } from "@/utils/permissionsMiddleWare";
import { skip, formatedDate } from "@/utils/helpers";
import messageTemplateManager from "@/utils/messageTemplateManager";
import Vue from "vue";

const state = {
  templates: [],
  reportsTemplate: [],
  pagination: {},
  reports: [],
  financeReport: [],
  templateDetails: [],
  patientReport: [],
  recieveablesReport: [],
  reportLedger: [],
  patinetDetails: {},
  details: [],
  employeeDetails: {},
  statusReport: [],
  historyId: "",
  excelReportUrl: null
};

const mutations = {
  set_templates(state, val) {
    state.templates = val;
  },
  set_pagination(state, val) {
    state.pagination = val;
  },
  set_reports(state, val) {
    state.reports = val;
  },
  set_history_id(state, val) {
    state.historyId = val;
  },
  doctor_report(state, val) {
    state.financeReport = val;
  },
  setReportTemplates(state, val) {
    state.reportsTemplate = val;
  },
  set_lookup_details(state, val) {
    state.templateDetails = val;
  },
  set_patient_report(state, val) {
    state.patientReport = val;
  },
  set_excel_report_url(state, url) {
    state.excelReportUrl = url;
  },
  set_recieveables_report(state, val) {
    state.recieveablesReport = val;
  },
  set_report_ledger(state, val) {
    state.reportLedger = val;
  },
  set_patient_details(state, val) {
    state.patinetDetails = val;
  },
  setDetailReport(state, val) {
    state.details = val.report;
    state.employeeDetails = val.employee;
  },
  setStatusReport(state, val) {
    state.statusReport = val;
  }
};

const actions = {
  async handleTemplateAdd({ dispatch, commit }, payload) {
    if (permissionsMiddleWare("Create Template")) {
      commit("set_loading", true, { root: true });
      await api.post("/template", payload);
      await dispatch("listTemplates");
      Vue.toasted.success("Template added successfully").goAway("3000");
      commit("set_loading", false, { root: true });
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : Create Template",
        { duration: 3000 }
      );
    }
  },
  async updateTemplate({ dispatch, commit }, { id, payload }) {
    if (permissionsMiddleWare("Update Template")) {
      commit("set_loading", true, { root: true });
      await api.put(`/template/${id}`, payload);
      dispatch("listTemplates");
      Vue.toasted.success("Template updated successfully").goAway("3000");
      commit("set_loading", false, { root: true });
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : Update Template",
        { duration: 3000 }
      );
    }
  },
  async listTemplates({ commit }, val) {
    if (permissionsMiddleWare("List Templates")) {
      try {
        const items = val ? skip(val) : 0;
        commit("set_loading", true, { root: true });
        const result = await api.get(
          `/template?take=${20}&skip=${items}&page_no=${val ? val : 1}`
        );
        const data = result.data.result;
        commit("set_templates", data.template);
        commit("set_pagination", data.pagination);
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : List Templates",
        { duration: 3000 }
      );
    }
  },
  async getLookupDetails({ commit }, id) {
    if (permissionsMiddleWare("View Template")) {
      const response = await api.get(`/template/${id}`);
      commit("set_lookup_details", response.data.result);
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : View Template",
        { duration: 3000 }
      );
    }
  },
  async templateReportsList({ commit }, update) {
    let templates;
    const dbName = "ReportsDB";
    const dbVersion = 1;

    const openDB = () => {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, dbVersion);
        request.onerror = event => reject(event.target.error);
        request.onsuccess = event => resolve(event.target.result);
        request.onupgradeneeded = event => {
          const db = event.target.result;
          db.createObjectStore("templates", { keyPath: "id" });
        };
      });
    };

    const fetchAndStoreTemplates = async db => {
      const response = await api.get(`/template?list=true`);
      templates = response.data && response.data.result.template;

      const transaction = db.transaction(["templates"], "readwrite");
      const objectStore = transaction.objectStore("templates");

      return new Promise((resolve, reject) => {
        const putRequest = objectStore.put({
          id: "reportTemplates",
          data: templates
        });
        putRequest.onerror = event => reject(event.target.error);
        putRequest.onsuccess = () => resolve(templates);
      });
    };

    try {
      const db = await openDB();

      if (update) {
        templates = await fetchAndStoreTemplates(db);
      } else {
        const transaction = db.transaction(["templates"], "readonly");
        const objectStore = transaction.objectStore("templates");
        const getRequest = objectStore.get("reportTemplates");

        templates = await new Promise((resolve, reject) => {
          getRequest.onerror = event => reject(event.target.error);
          getRequest.onsuccess = event => {
            const result = event.target.result;
            resolve(result ? result.data : null);
          };
        });

        if (!templates) {
          templates = await fetchAndStoreTemplates(db);
        }
      }

      commit("setReportTemplates", templates);
    } catch (error) {
      console.error("Error in templateReportsList:", error);
      templates = [];
      commit("setReportTemplates", templates);
    }
  },
  async addHistory({ commit, dispatch }, payload) {
    if (permissionsMiddleWare("Create History")) {
      try {
        commit("set_loading", true, { root: true });
        const patinetId = router.currentRoute.params.id || payload.patientId;
        const history = await api.post("/history", payload);
        commit("set_loading", false, { root: true });
        commit("set_history_id", history?.data?.result?.id);
        await dispatch("receptionist/listHistory", patinetId, { root: true });
        return history?.data?.result;
      } catch (error) {
        commit("set_loading", false, { root: true });
        throw error; // Re-throw the error to propagate it further
      }
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action: Create History"
      );
    }
  },
  async updateHistory({ commit, dispatch }, { id, payload }) {
    try {
      if (permissionsMiddleWare("Update History")) {
        commit("set_loading", true, { root: true });
        const history = await api.put(`/history/${id}`, payload);
        commit("set_history_id", history.data.result.id);
        await dispatch("receptionist/listHistory", payload.patientId, {
          root: true
        });
        commit("set_loading", false, { root: true });
        return history?.data?.result;
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Update History",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
      throw error;
    }
  },

  async searchTemplates({ commit }, query) {
    if (permissionsMiddleWare("Search Template")) {
      try {
        commit("set_loading", true, { root: true });
        const result = await api.get(`/template/search?query=${query}`);
        commit("set_templates", result.data.result);
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted.info(
        "This action cannot be performed by you due to insufficient authorization. Action : Search Template",
        { duration: 3000 }
      );
    }
  },
  async listReports({ commit, rootState }, payload) {
    const { isOther } = rootState.auth.user;
    try {
      commit("set_loading", true, { root: true });
      const result = await api.get("/history/finance-report", {
        params: { ...payload, isOther: isOther }
      });
      commit("set_reports", result.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async listReportsByBranch({ commit, rootState }, payload) {
    const { isOther } = rootState.auth.user;
    try {
      commit("set_loading", true, { root: true });
      const result = await api.get("/history/finance-report", {
        params: { ...payload, isOther: isOther }
      });
      commit("set_reports", result.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  createPdf(
    { commit, dispatch, rootState },
    { payload, report, vm, sendToDoctor }
  ) {
    const id = rootState.receptionist && rootState.receptionist.patient.id;
    const patinetId = router.currentRoute.params.id || id;
    const isOther = rootState?.auth?.user?.isOther;
    const status = {
      status: 3
    };
    commit("set_loading", true, { root: true });
    api
      .post("/attachment/create-pdf", payload)
      .then(res => {
        const path =
          res.data && res.data.attachment && res.data.attachment.path;
        const reportName = report?.name || "";
        const isUltrasoundReport =
          typeof reportName === "string" &&
          reportName.toUpperCase().includes("ULTRASOUND");
        // Use template system for SMS message
        const smsMessage = messageTemplateManager.getNextSmsTemplate({
          patientName: report.patient || "",
          reportName: report.name
        });

        const sms = {
          to: report.contactNumber,
          url: path,
          message: smsMessage,
          reportType: report.name,
          patientId: report.patientId
        };
        console.log("report", report);

        // Use template system for doctor message
        const doctorMessageText = report.cellNo
          ? messageTemplateManager.getNextDoctorTemplate({
              patientName: report.patient || "",
              reportName: report.name
            })
          : "";

        const doctorMessage = {
          to: report.cellNo,
          url: path,
          message: doctorMessageText,
          reportType: report.name,
          patientId: report.patientId
        };

        // Never send patient SMS for ultrasound reports
        if (!isUltrasoundReport && report.contactNumber) {
          dispatch("sendSms", { sms: sms, vm: vm });
          dispatch("sendMessage", {
            sms: doctorMessage,
            vm: vm,
            sendSms: sendToDoctor
          });
        } else if (!isUltrasoundReport && report.cellNo && isOther !== 1) {
          dispatch("sendMessage", {
            sms: doctorMessage,
            vm: vm,
            sendSms: sendToDoctor
          });
        }

        // Continue with status update and history refresh without waiting for SMS
        dispatch("setHistoryStatus", {
          id: report.id,
          payload: status
        }).then(() => {
          dispatch("receptionist/listHistory", patinetId, {
            root: true
          }).then(() => {
            commit("set_loading", false, { root: true });
          });
        });
      })
      .catch(() => {
        commit("set_loading", false, { root: true });
      });
  },

  sendSms({ commit }, { sms, vm }) {
    // Run SMS sending asynchronously without blocking other operations
    api
      .post("/user/sms", sms)
      .then(res => {
        if (res.data.message) {
          vm.$toasted.success(res.data.message).goAway("3000");
        }
      })
      .catch(error => {
        vm.$toasted
          .error("Message couldn't send to the patient")
          .goAway("3000");
        console.error("SMS sending failed:", error);
      });
  },
  sendMessage({ commit }, { sms, vm, sendSms }) {
    if (sms.to && sendSms === true) {
      // Run message sending asynchronously without blocking other operations
      setTimeout(() => {
        api
          .post("/user/sms", sms)
          .then(res => {
            if (res.data.message) {
              vm.$toasted.success("Message send to the doctor").goAway("3000");
            }
          })
          .catch(error => {
            vm.$toasted
              .error("Message couldn't send to the patient")
              .goAway("3000");
            console.error("Message sending failed:", error);
          });
      }, 1000); // 7 seconds delay
    }
  },

  setHistoryStatus({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      if (permissionsMiddleWare("Update History Status")) {
        api
          .put(`/history/report/${id}`, payload)
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Update History Status",
          { duration: 3000 }
        );
      }
    });
  },

  async templateDelete({ commit, dispatch }, id) {
    try {
      commit("set_loading", true, { root: true });
      await api.delete(`/template/delete/${id}`);
      await dispatch("listTemplates");
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async filterDoctorReports({ commit }, payload) {
    try {
      if (permissionsMiddleWare("Doctor Report")) {
        commit("set_loading", true, { root: true });
        const result = await api.get("/history/doctor-report", {
          params: { ...payload }
        });
        commit("doctor_report", result.data.result);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Doctor Report",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async patientDailyReport({ commit, rootState }, payload) {
    try {
      if (permissionsMiddleWare("Patient Report")) {
        commit("set_loading", true, { root: true });
        const response = await api.get("/history/patients-report", {
          params: { ...payload }
        });
        commit("set_patient_report", response.data.result);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Patient Report",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async downloadExcelReport({ commit, rootState }, payload) {
    try {
      commit("set_loading", true, { root: true });
      const response = await api.get("/history/patients-report-xlsx", {
        params: { ...payload }
      });
      commit("set_excel_report_url", response.data.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async recieveablesReportList({ commit }, payload) {
    try {
      if (permissionsMiddleWare("Receivable Report")) {
        commit("set_loading", true, { root: true });
        const response = await api.get("/history/receivable-report", {
          params: { ...payload }
        });
        commit("set_recieveables_report", response.data.result);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Receivable Report",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },
  async reportLedgerDetails({ commit }, { id, payload }) {
    if (permissionsMiddleWare("Patient Ledger")) {
      try {
        commit("set_loading", true, { root: true });
        const response = await api.get(`/history/patient-ledger/${id}`, {
          params: { ...payload }
        });
        const patient =
          response.data.result &&
          response.data.result.patient &&
          response.data.result.patient[0];
        commit(
          "set_report_ledger",
          response.data.result && response.data.result.ledger
        );
        commit("set_patient_details", patient);
        commit("set_loading", false, { root: true });
      } catch (error) {
        commit("set_loading", false, { root: true });
      }
    } else {
      Vue.toasted
        .info(
          "This action cannot be performed by you due to insufficient authorization. Action: Patient Ledger"
        )
        .goAway("3000");
    }
  },
  async insurancePaid({ commit, dispatch }, { id, payload }) {
    try {
      commit("set_loading", true, { root: true });
      await api.put(`/history/insurance-paid/${id}`);
      await dispatch("reportLedgerDetails", {
        id: router.currentRoute.params.id,
        payload: payload
      });
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },

  async detailReport({ commit }, filters) {
    try {
      if (permissionsMiddleWare("Doctor Service Visit")) {
        commit("set_loading", true, { root: true });
        const response = await api.get("/history/service-visits", {
          params: { ...filters }
        });
        commit("setDetailReport", response?.data?.result);
        commit("set_loading", false, { root: true });
      } else {
        Vue.toasted.info(
          "This action cannot be performed by you due to insufficient authorization. Action : Doctor Service Visit",
          { duration: 3000 }
        );
      }
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  },

  async listStatusReport({ commit }, filters) {
    try {
      commit("set_loading", true, { root: true });
      const response = await api.get("/history/status-report", {
        params: { ...filters }
      });
      commit("setStatusReport", response?.data?.result);
      commit("set_loading", false, { root: true });
    } catch (error) {
      commit("set_loading", false, { root: true });
    }
  }
};

const getters = {
  getTemplates: state => state.templates,
  pagination: state => state.pagination,
  reportsList: state => state.reports,
  financeReport: state => state.financeReport,
  reportsTemplate: state => state.reportsTemplate,
  templateDetails: state => state.templateDetails,
  patientReport: state => state.patientReport,
  recieveablesReport: state => state.recieveablesReport,
  reportLedger: state => state.reportLedger,
  patinetDetails: state => state.patinetDetails,
  statusReport: state => state.statusReport,
  details: state => state.details,
  employeeDetails: state => state.employeeDetails,
  excelReportUrl: state => state.excelReportUrl
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
